import Annotate from "./Annotate";
import CurrentReadingGroup from "./CurrentReadingGroup";
import Highlight from "./Highlight";
import Resource from "./Resource";
import Share from "./Share";

export default {
  Annotate,
  CurrentReadingGroup,
  Highlight,
  Resource,
  Share
};
